import { render, staticRenderFns } from "./operation-cool.vue?vue&type=template&id=632f1bea&scoped=true"
import script from "./operation-cool.vue?vue&type=script&lang=js"
export * from "./operation-cool.vue?vue&type=script&lang=js"
import style0 from "./operation-cool.vue?vue&type=style&index=0&id=632f1bea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632f1bea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('632f1bea')) {
      api.createRecord('632f1bea', component.options)
    } else {
      api.reload('632f1bea', component.options)
    }
    module.hot.accept("./operation-cool.vue?vue&type=template&id=632f1bea&scoped=true", function () {
      api.rerender('632f1bea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/operation-cool.vue"
export default component.exports